export default __webpack_public_path__ + "static/media/myplanimg.6ede4216.jpg";